import { Button } from "antd";
import { saveAs } from "file-saver";
import React from "react";
import * as XLSX from "xlsx";

/** Format salary to 2 decimal places for export. Handles null, undefined, and invalid numbers. */
const formatSalaryForExport = (salary) => {
  const n = Number(salary);
  if (salary == null || Number.isNaN(n)) return "";
  return n.toFixed(2);
};

/** Format date for export in DD/MM/YYYY format. Handles null, undefined, and invalid dates. */
const formatDateForExport = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

/** Split name into first name and last name. Returns an object with nombre and apellido. */
const splitName = (fullName) => {
  if (!fullName || typeof fullName !== "string") return { nombre: "", apellido: "" };
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return { nombre: "", apellido: "" };
  if (parts.length === 1) return { nombre: parts[0], apellido: "" };
  // First part is nombre, rest is apellido
  return {
    nombre: parts[0],
    apellido: parts.slice(1).join(" ")
  };
};

const ExportEmployees = ({ employees }) => {
  const exportToExcel = () => {
    const workBook = XLSX.utils.book_new();
    const workSheet = XLSX.utils.json_to_sheet(
      employees.map((employee) => {
        const { nombre, apellido } = splitName(employee.name);
        return {
          "NRO DE AFILIADO": employee.numero_afiliado || "",
          "FECHA DE AFILIACION": formatDateForExport(employee.alta),
          "NOMBRE": nombre,
          "APELLIDO": apellido,
          "DNI": employee.dni || "",
          "CUIL": employee.cuil || "",
          "SALARIO": formatSalaryForExport(employee.salary),
          "TELEFONO": employee.phoneNumber || "",
          "EMAIL": employee.email || "",
          "DIRECCION": employee.domicilio || "",
          "LOCALIDAD": employee.ciudad || "",
          "PROVINCIA": employee.provincia || ""
        };
      })
    );

    // Paso 2: Agregar la hoja de trabajo al libro de trabajo
    XLSX.utils.book_append_sheet(workBook, workSheet, "Empleados");

    // Paso 3: Generar el archivo Excel y descargarlo
    const excelBuffer = XLSX.write(workBook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Empleados.xlsx");
  };

  return (
    <Button onClick={exportToExcel} type="primary">
      Exportar a Excel
    </Button>
  );
};

export default ExportEmployees;
